import { PaginatedQuery } from './PaginatedQuery';
import { Filter, FilterTypes } from './Filter';
import { Facet } from './Facet';

export interface ProductSearchFacetExpression {
  attributeType: string;
  attributeId: string;
  attributeLabel: string;
}

export enum SortOrder {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}

export enum SortOrderType {
  FEATURED = 'Featured',
  TOP_SELLERS = 'Top Sellers',
  NEWEST = 'New',
  PRICE_ASC = 'Price Low to High',
  PRICE_DESC = 'Price High to Low',
}

export interface Sort {
  field: string;
  fieldType: string;
  order: SortOrder;
  orderType: SortOrderType;
}

export interface Exclude {
  field: string;
  value: string | string[];
}

export interface FacetFilter {
  key: string;
  urlKey: string;
  facetData: {
    facetType: FilterTypes;
    terms?: string[];
  };
}

export interface ProductQuery extends PaginatedQuery {
  [key: string]: any;
  categories?: string[];
  categoriesIds?: string[];
  productIds?: string[];
  productKeys?: string[];
  productRefs?: string[];
  productType?: string;
  skus?: string[];
  slug?: string;
  query?: string;
  filters?: Filter[];
  facets?: Facet[];
  activeFacets?: FacetFilter[];
  facetDefinitions?: ProductSearchFacetExpression[];
  postFilter?: FacetFilter[];
  sort?: Sort;
  productSelectionIds?: string[];
  exclude?: Exclude[];
  categorySlug?: string;
}
